import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';

export const getWebUiUrl = (webui?: string | null): string | null => {
	if (!webui) {
		return null;
	}

	return new URL(`${CONTEXT_PATH}${webui}`, window.location.origin).toString();
};
